/* eslint-disable react/prop-types */

// A handful of drawn icons in the album's one line weight.
const PATHS = {
  out: 'M7 17 17 7M9 7h8v8',
  right: 'M4 12h15M13 6l6 6-6 6',
  sun: 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10ZM12 1.5v2.5M12 20v2.5M1.5 12H4M20 12h2.5M4.6 4.6l1.8 1.8M17.6 17.6l1.8 1.8M4.6 19.4l1.8-1.8M17.6 6.4l1.8-1.8',
  moon: 'M20 14.5A8.5 8.5 0 0 1 9.5 4 8.5 8.5 0 1 0 20 14.5Z',
  sound: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4ZM15.5 9a4.5 4.5 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11',
  mute: 'M4 9.5h3.5L12 5.5v13l-4.5-4H4ZM16 9.5l5 5M21 9.5l-5 5',
  down: 'M12 4v15M6 13l6 6 6-6',
}

const Icon = ({ name, className = 'size-5' }) => (
  <svg
    aria-hidden='true'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2.5'
    strokeLinecap='round'
    strokeLinejoin='round'
    className={`shrink-0 ${className}`}
  >
    <path d={PATHS[name]} />
  </svg>
)

export default Icon
